"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const Integration_1 = require("../Integration");
let CampaignMonitor = class CampaignMonitor extends Integration_1.Integration {
    constructor() {
        super(...arguments);
        this.integrationType = 'CampaignMonitor';
        this.displayType = 'Campaign Monitor';
        this.isESP = true;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], CampaignMonitor.prototype, "integrationType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", Object)
], CampaignMonitor.prototype, "displayType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], CampaignMonitor.prototype, "canConnect", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Object)
], CampaignMonitor.prototype, "isESP", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], CampaignMonitor.prototype, "campaignMonitorClientName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], CampaignMonitor.prototype, "campaignMonitorClientId", void 0);
CampaignMonitor = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.ChildEntity()
], CampaignMonitor);
exports.CampaignMonitor = CampaignMonitor;
class CampaignMonitorEntity extends CampaignMonitor {
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return `/integrations/${this.id}`;
        });
    }
    toString() {
        return this.name;
    }
}
exports.CampaignMonitorEntity = CampaignMonitorEntity;
//# sourceMappingURL=CampaignMonitor.js.map